import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button, Popover, MenuItem, Tabs, Tab } from '@mui/material'
import { useFormik } from 'formik'
import {
    handleRedirectInternal,
    mapData,
} from '../../product/common/components'
import ProductContext from '../../product/context/product/productContext'
import SettingContext from '../../product/context/setting/settingContext'
import * as Yup from 'yup'
import { useHistory } from 'react-router'
import InventoryLogs from './view'
import Catalogue from '@/product/customViews/ERP/Catalogue'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import CustomCommonContext from '@/custom/context/common/commonContext'

const Inventory = (props) => {
    const reportContext = useContext(ReportContext)
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const [isLoading, setIsLoading] = useState(true)
    const { getAllExportDownload } = reportContext
    const { user } = authContext
    const [searchVisible, setSearchVisible] = useState(false)
    const [showButton, setShowButton] = useState(false)
    const [selectedValues, setSelectedValues] = useState([])
    const [reload, setReload] = useState(false)
    const [idValue, setIdValue] = useState(0)

    const productContext = useContext(ProductContext)
    const settingcontext = useContext(SettingContext)
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const { alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)

    const {
        all_invoices,
        getAllInvoices,
        single_invoice,
        getSingleInvoice,
        getInvoiceDetails,
        invoice_details,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext
    const {
        all_products,
        getAllProducts,
        changeProductStatus,
        responseStatus: responseStatusProduct,
    } = productContext

    const [changeStatus, setChangeStatus] = React.useState(false)

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup) {
            setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const toggleCreditsPopup = (popup, status, id, sid) => {
        if (popup) {
            setManageCredits({ popup, status, id, sid })
        } else {
            setManageCredits({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    let action = props.match.params.action

    const [tableBody, setTableBody] = useState([])
    const [searchData, setSearchData] = useState([])

    const formikInvoice = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                action: {
                    value: action ? action.toString() : null,
                    type: 'in',
                    field: 'b.paid',
                },
                active: {
                    value: 2,
                    type: 'all',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                fromdate: {
                    value: '',
                    type: 'like',
                    field: 'b.paid_date',
                },
                todate: {
                    value: '',
                    type: 'like',
                    field: 'b.paid_date',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                id: {
                    value: '0',
                    type: 'in',
                    field: 'p.id',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'p.date_closed',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'p.date_closed',
                },
            },
        },
        // validationSchema: Yup.object({
        //     id: Yup.string().required('Required!'),
        // }),
        onSubmit: (values) => {
            setIsLoading(true)
            if (values.filters.id.value === '') {
                values.filters.id.value = '0'
            }
            getAllProducts(values, 'inventory')
            setIdValue(values.filters.id.value)
        },
    })

    const formikSearch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                location: {
                    value: 'null',
                    type: 'notin',
                    field: 'it.inventory_location',
                },
            },
        },
        onSubmit: (values) => {
            getAllProducts(values)
        },
    })

    const formikInventory = useFormik({
        initialValues: {
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: '',
            primaryTable: 'inventory_logs',
            filters: {
                active: {
                    value: 1,
                    type: 'in',
                    field: 'il.active',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'active_inventory')
            setIsLoading(true)
        },
    })

    const handleConfirm = (data) => {
        let newSelected = []
        if (data !== '' && !searchData.includes(parseInt(data))) {
            let newValue = parseInt(data)
            newSelected = newSelected.concat(searchData, newValue)
            setSearchData(newSelected)
        }
        console.log(newSelected, 'newww')
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_ids: '',
            inventory_location: '',
            notes: '',
        },
        validationSchema: Yup.object({
            inventory_location: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            if (values.action === 'inventory_update') {
                changeProductStatus(values)
            }
        },
    })

    useEffect(() => {
        setTableBody([])
        setSearchData([])
        setSearchVisible(false)
        formik.values.auctionid = 0
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        if (action === 'active') {
            // searchTableFetch(
            //     {
            //         page: 1,
            //         limit: 1000,
            //         order: 'asc',
            //         orderby: '',
            //         primaryTable: 'inventory_logs',
            //         filters: {
            //             active: {
            //                 value: 1,
            //                 type: 'in',
            //                 field: 'il.active',
            //             },
            //         },
            //     },
            //     'active_inventory',
            // )
            getAllProducts(formikSearch.values, 'activeInventory')
            setIsLoading(true)
        }
    }, [action])

    useEffect(() => {
        if (all_products) {
            console.log('getAllProducts ', all_products)
            if (
                all_products.from === 'inventory' &&
                all_products.records.length
            ) {
                console.log(all_products.records)
                let value = all_products.records[0]
                console.log(all_products.records[0].id, 'kdddd')
                if (!searchData.includes(all_products.records[0].id)) {
                    setTableBody([...tableBody, value])
                }
            } else if (
                all_products.from === 'activeInventory' &&
                all_products.records.length
            ) {
                setTableBody(all_products.records)
            } else if (action === 'active') {
                setTableBody(all_products.records)
            } else {
                setTableBody([])
            }
        }
        setIsLoading(false)
    }, [all_products])

    useEffect(() => {
        if (search_fetch_data) {
            console.log('search_fetch_data', search_fetch_data)
            if (search_fetch_data.from === 'active_inventory') {
                if (action === 'active') {
                    setTableBody(
                        search_fetch_data.records.length
                            ? search_fetch_data.records
                            : []
                    )
                    console.log('search_fetch_data', search_fetch_data)
                    setIsLoading(false)
                }
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (tableBody.length) {
            console.log(idValue, 'iiiii')
            handleConfirm(idValue)
        }
    }, [tableBody])

    useEffect(() => {
        console.log('formikSelection.values', formikSelection.values)
    }, [formikSelection.values])

    const onClickView = (id, sid, type) => {
        console.log('sid', sid)
        console.log('typpeee', type, id)
        toggleFullScreenPopup(true, type, id, sid)
    }

    const onClickEdit = (id, secondaryID, type) => {
        toggleCreditsPopup(true, type, id, secondaryID)
    }

    const onSelectMultiProducts = (data, action) => {
        console.log(data, 'dddd')
        formikSelection.values.action = action
        formikSelection.values.project_ids = data
        if (action === 'inventory_update') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                tooltipTitle: 'View invoice',
            },
        ]
        if (action === 'unpaid' || action === 'draft') {
            actionPush.push({
                buttonType: 'monetization_on',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Make payment',
            })
        }
        return actionPush
    }

    const onClickPreview = (id, type) => {
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${id}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const tableValues = []

    tableValues.push(
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            sortField: 'p.id',
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'p.id',
        },
        {
            field: 'avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
        },
        {
            field: 'title',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickPreview,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory Title',
            filterable: true,
            filterField: 'p.title',
        },
        {
            field: 'inventory_location',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory Location',
            filterable: true,
            filterField: 'p.inventory_location',
        }
    )

    tableValues.push(
        {
            field: 'wprice',
            type: 'price',
            firstChild: false,
            sort: true,
            sortField: 'p.wprice',
            disablePadding: false,
            label: 'Current price',
            filterable: true,
            filterField: 'p.wprice',
        },
        {
            field: 'rprice',
            type: 'price',
            firstChild: false,
            sort: true,
            sortField: 'p.rprice',
            disablePadding: false,
            label: 'Reserve price',
            filterable: true,
            filterField: 'p.rprice',
        },
        {
            field: 'market_status',
            sortField: 'p.market_status',
            type: 'capitalize',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Status',
            filterable: true,
            filterField: 'p.market_status',
        },
        {
            field: 'manufacturer',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Manufacturer',
            filterable: true,
            valueOptions: alldata_all_dropdown
                .filter(
                    (data) => data.level == 0 && data.variable == 'manufacturer'
                )
                .map((data) => {
                    let valueChanged = {}
                    console.log(data, 'ghghh')
                    valueChanged.label = data.description
                    valueChanged.value = data.id.toString()
                    console.log(valueChanged, 'vhnjnj')
                    return valueChanged
                }),
            filterField: 'it.manufacturer',
        },
        {
            field: 'location',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Location',
            filterable: true,
            valueOptions: allLocations.map((data) => {
                let valueChanged = {}
                console.log(data, 'ghghh')
                valueChanged.label = data.name
                valueChanged.value = data.id.toString()
                console.log(valueChanged, 'vhnjnj')
                return valueChanged
            }),
            filterField: 'it.location',
        },
        {
            field: 'brand',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Brand',
            filterable: true,
            filterField: 'it.brand',
        },
        {
            field: 'asin_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'ASIN ID',
            filterable: true,
            filterField: 'it.asin_id',
        },
        {
            field: 'home_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Home Depot Id',
            filterable: true,
            filterField: 'it.home_id',
        },
        {
            field: 'category',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            valueOptions: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'category' && value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.label = item.description
                    valueChanged.value = item.id.toString()
                    return valueChanged
                }),
            label: 'Category',
            filterable: true,
            filterField: 'it.category',
        },
        {
            field: 'conditionTypeId',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            disablePadding: false,
            valueOptions: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'conditionTypeId' &&
                        value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.label = item.description
                    valueChanged.value = item.id.toString()
                    return valueChanged
                }),
            label: 'Condition',
            filterable: true,
            filterField: 'p.conditionTypeId',
        },
        {
            field: 'upc',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'UPC',
            filterable: true,
            filterField: 'it.upc',
        },
        {
            field: 'sku',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'SKU',
            filterable: true,
            filterField: 'it.sku',
        },
        {
            field: 'bin_location',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Bin Location',
            filterable: true,
            filterField: 'it.bin_location',
        }
    )

    tableValues.push(
        {
            field: 'date_added',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Start date',
            filterable: true,
            filterField: 'p.date_added',
        },
        {
            field: 'date_closed',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'End date',
            filterable: true,
            filterField: 'p.date_closed',
        }
    )

    tableValues.push(
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Created At',
        },
        {
            field: 'updated_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Updated At',
        },
        {
            field: 'as_employees_emp_firstname,as_employees_emp_lastname',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Posted By',
        }
    )

    if (action === 'active') {
        tableValues.push({
            field: 'action',
            type: 'button',
            buttonType: 'history',
            clickType: 'logs',
            onclick: onClickView,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Location History',
            tooltipTitle: 'Location History',
        })
    }

    const tableActions = []

    tableActions.push({
        label: 'Update Inventory',
        icon: <span className="material-icons">inventory</span>,
        onclick: onSelectMultiProducts,
        type: 'inventory_update',
    })

    const orderData = {
        formik: formik,
        data: [
            {
                label: 'Product ID',
                placeholder: 'Enter product id',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'id',
                filter: true,
            },
        ],
    }

    const handleOrderSubmit = () => {
        if (selectedValues.length) {
            formikSelection.values.action = 'delivered'
            formikSelection.values.project_ids = selectedValues
            setChangeStatus(true)
        }
    }

    const selectedUpdate = (data) => {
        console.log(data, 'sdddd')
        if (data.length) {
            setShowButton(true)
        } else {
            setShowButton(false)
        }
        setSelectedValues(data)
    }

    const locationData = [
        {
            label: 'Inventory Location',
            name: 'inventory_location',
            type: 'text',
            placeholder: 'Enter Inventory Location',
            formik: formikSelection,
        },
        {
            label: 'Notes',
            name: 'notes',
            type: 'text',
            placeholder: 'Enter Inventory Notes',
            formik: formikSelection,
        },
    ]

    useEffect(() => {
        if (responseStatusProduct) {
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct.from === 'productchange'
            ) {
                setChangeStatus(false)
                formik.values.filters.id.value = ''
                formikSelection.values.inventory_location = ''
                formikSelection.values.notes = ''
                if (action === 'add') {
                    setTableBody([])
                    setSearchData([])
                } else {
                    getAllProducts(formikSearch.values)
                }
            }
        }
    }, [responseStatusProduct])

    const [bulkPopup, setBulkPopup] = useState(false)
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const [catalogPopup, setCatalogPopup] = useState(false)
    const [actionsAAnchor, setActionsAnchor] = useState(null)

    const handlePhotosClick = (event) => {
        setActionsAnchor(event.currentTarget)
    }

    const handleClose = () => {
        setActionsAnchor(null)
    }

    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    const toggleCatalougePopup = (popup) => {
        setCatalogPopup({ popup })
    }

    const toggleListingPopup = (popup, status, id) => {
        if (popup && status != '') {
            handleRedirectInternal(history, `listing/${status}/${id}`)
        }
    }

    const history = useHistory()

    return (
        <Layout>
            <div className="dashboard listing">
                {action === 'add' ? (
                    <CustomSearch searchInfo={orderData} formik={formik} />
                ) : null}

                <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 erp-menus-list">
                    <Button
                        id="dynamicAuction_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            handleRedirectInternal(history, `auction/new/0`)
                        }
                    >
                        <span className="material-icons">add</span>
                        Create a new auction
                    </Button>
                    <Button
                        id="listingDynamic_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleListingPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">add</span>
                        Add single inventory
                    </Button>
                    <Button
                        id="listingDynamic_bulk"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleBulkPopup(true)}
                    >
                        <span className="material-icons-outlined">
                            inventory_2
                        </span>
                        Add bulk inventory
                    </Button>
                    <Button
                        id="dynamicAuction_report"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${action}_auction_management`,
                            })
                        }
                    >
                        <span className="material-icons-outlined">
                            file_download
                        </span>
                        Export All Data
                    </Button>
                    <Button
                        variant="outlined"
                        className="btnOutlined moreActions"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handlePhotosClick}
                    >
                        More Actions
                        <span className="material-icons">expand_more</span>
                    </Button>
                    <Popover
                        id="simple-menu"
                        anchorEl={actionsAAnchor}
                        keepMounted
                        open={Boolean(actionsAAnchor)}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                toggleBulkImagePopup(true)
                                handleClose()
                            }}
                        >
                            Add Bulk Images
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                toggleCatalougePopup(true)
                                handleClose()
                            }}
                        >
                            View Catalog
                        </MenuItem>
                        <MenuItem
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    'campaign/template'
                                )
                            }
                        >
                            View Marketing
                        </MenuItem>
                    </Popover>
                </div>
                <CustomTable
                    formik={
                        action === 'add' ? formik.values : formikSearch.values
                    }
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={{ totalRecords: tableBody.length }}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    searchData={searchData}
                    selectedUpdate={selectedUpdate}
                    changeTableFunction={getAllProducts}
                    fromVariable={'activeInventory'}
                />
            </div>
            <CustomDialog
                title={'Update Inventory'}
                open={changeStatus}
                function={changeChangeStatus}
                disableBackdropClick={true}
            >
                {formikSelection.values.action === 'inventory_update' &&
                    mapData(locationData)}
                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="inventory_update"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <InventoryLogs data={manage} function={toggleFullScreenPopup} />
            <Catalogue data={catalogPopup} function={toggleCatalougePopup} />

            <DynamicBulkListing
                data={bulkPopup}
                function={toggleBulkPopup}
                ignoreFields={
                    global?.bulk_ignoreFields ? global.bulk_ignoreFields : []
                }
            />
            <DynamicBulkImage
                data={bulkImagePopup}
                function={toggleBulkImagePopup}
                explanationText={`Bulk Image Upload reads the file name of each image and will automatically add to the listings image. The name of the files has to be given in the format of {AuctionField}_{ListingField}-{N}.{ImageFormat} or {AuctionField}_{ListingField} ({N}).{ImageFormat}. <br />  {AuctionField} From Auction Posting: "Auction Cycle" Field has to be given first. <br/> {ListingField} From Listing Posting: "Lot ID" Field has to be given. <br/> {N} Number - Can be any number, as uploading multiple images with same name is not possible, When renaming the number will be automatically added by OS (Mac or Windows). <br /> {ImageFormat} Image Format: Image Format can be .jpg, .png or .webp. <br /> Between the two fields "_" should be given.`}
                separatorFunction={[
                    {
                        symbol: '_',
                        field: 'cac.auction_cycle',
                        table: 'auction',
                        show: 'Auction Cycle',
                    },
                    {
                        symbol: '_',
                        field: 'it.auction_lot',
                        table: 'project',
                        show: 'Lot ID',
                    },
                ]}
                isCompress={global?.isCompress ? global.isCompress : false}
            />
        </Layout>
    )
}

export default Inventory
